import { takeLatest } from 'redux-saga/effects';

import { downloadMeetingReportSaga, meetingListSaga } from './meetingSaga';
import sagaActions from '../../actions/index';

export function* meetingSaga() {
  yield takeLatest(sagaActions.GET_MEETING_DETAILS, meetingListSaga);
  yield takeLatest(sagaActions.DOWNLOAD_MEETING_DETAILS, downloadMeetingReportSaga);
}
